exports = module.exports = require("../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".Button__root___DCzKg {\n  display: inline-block;\n  margin: 0 5px 0 0;\n  padding: 3px 8px;\n  height: 30px;\n  line-height: 22px;\n  box-sizing: border-box;\n  background: none #fdfdfd;\n  background: linear-gradient(to bottom, #fdfdfd 0%,#f6f7f8 100%);\n  border: 1px solid #999;\n  border-radius: 2px;\n  color: #333;\n  text-decoration: none;\n  font-size: inherit;\n  font-family: inherit;\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.Button__root___DCzKg:disabled {\n  cursor: not-allowed;\n  background: none transparent;\n}\n\n.Button__root___DCzKg:disabled > * {\n  opacity: .5;\n}\n", ""]);

// Exports
exports.locals = {
	"root": "Button__root___DCzKg"
};


//////////////////
// WEBPACK FOOTER
// ../css-loader/dist/cjs.js??ref--2-1!../react-rte/lib/ui/Button.css
// module id = 2147
// module chunks = 25